import React, { Component } from "react";
import { Input } from "../../forms/input";
import Signbutton from "../../forms/button";
import { connect } from "react-redux";
import CustomizedSelect from "./customizedSelect";
import MenuItem from "@material-ui/core/MenuItem";

import {
  getNewPurchaseFundList,
  validateSubBroker,
  getInvestorDetails,
  submitPurchaseData,
  showPurchaseConfirmation,
  saveTransactionDetails,
} from "../../../store/actions";
import {
  GET_CATEGORY_LIST,
  GET_CATEGORY_LIST_SUCCESS,
  GET_SCHEME_LIST,
  GET_SCHEME_LIST_SUCCESS,
  GET_CATEGORY_LIST_FAILED,
  GET_SCHEME_LIST_FAILED,
  PURCHASE,
  REGULAR,
  NO,
  YES,
  NEW_PURCHASE,
  NEW,
  NEWP,
} from "../../../store/types";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import IntegrationReactSelect from "../../forms/autoCompleteInput";
import { NEW_TRANSACTION_URL, countrycodeOptions } from ".";

class NewPurchase extends Component {
  constructor(props) {
    super(props);

    const { investorData, communicationDetails = [], token } = this.props;
    const revCD =
      !!communicationDetails && communicationDetails.length > 0
        ? communicationDetails.reverse()
        : "";
    const Xmobile = (revCD || []).find(
      (detail) =>
        detail.PAN === investorData.PAN &&
        !!detail.Mobile &&
        !!detail.Fund &&
        detail.Fund === "189"
    );
    const Xemail = (revCD || []).find(
      (detail) =>
        detail.PAN === investorData.PAN &&
        !!detail.email &&
        !!detail.Fund &&
        detail.Fund === "189"
    );
    const Email = !!Xemail && !!Xemail.email ? Xemail.email : "";
    const Mobile = !!Xmobile && !!Xmobile.Mobile ? Xmobile.Mobile : "";

    this.state = {
      emailId: { value: Email || "" },
      mobile: { value: Mobile || "" },
      disbleEmail: !!Email ? true : false,
      disbleMobile: !!Mobile ? true : false,
      arnCode: { value: token },
      invName: { value: this.props.investorData.invname || "" },
      fund: { value: "189" },
      category: { value: "" },
      scheme: { value: "" },
      subArnCode: { value: "" },
      multiples: "",
      euinNo: { value: "" },
      radioValue: { value: "no" },
      minAmount: { value: "" },
      subBrokerCode: { value: "" },
      code: { value: "+91" },
      Family_Code_Email: { value: "" },
      Family_Code_Phone: { value: "" },
    };
  }

  async componentDidMount() {
    const { transactionDetails } = this.props;
    if (Object.keys(transactionDetails).length > 0) {
      this.setState(transactionDetails);
      return;
    }
    const params = {
      opt: "AT",
      plntype: REGULAR,
      fund: "189",
    };
    const types = [
      GET_CATEGORY_LIST,
      GET_CATEGORY_LIST_SUCCESS,
      GET_CATEGORY_LIST_FAILED,
    ];
    const response = await this.props.getNewPurchaseFundList(params, types);
  }
  FamilyDescriptionEmail = (event) => {
    this.setState({
      Family_Code_Email: { value: event },
    });
  };
  FamilyDescriptionPhone = (event) => {
    this.setState({
      Family_Code_Phone: { value: event },
    });
  };

  validateBrokerCode = async () => {
    if (
      !!this.state.subArnCode.value &&
      this.state.subArnCode.value === this.state.arnCode.value.split("-")[1]
    ) {
      this.setState({
        subArnCode: {
          value: "",
          isError: true,
          errorMessage: "ARN and Sub ARN Code should not be the same",
        },
      });
      return;
    }

    const { fund, subArnCode, arnCode } = this.state;
    const params = {
      Fund: "189",
      SubAgentCd: !!subArnCode.value ? `ARN-${subArnCode.value}` : "",
      AgentCd: arnCode.value,
    };
    const response = await this.props.validateSubBroker(params);
    if (!!response && !!response.DtData && response.DtData.length > 0) {
      const getLength = response.DtData.length === 1;
      let value = {
        value: response.DtData[0].abm_agent,
        label: response.DtData[0].abm_agent,
      };
      if (!!getLength) {
        this.setState({
          euinNo: { value },
        });
      }
    }

    // if (!response) {
    //   alert(`${response}`);
    //   // this.setState({
    //   //   subArnCode: {
    //   //     value: "",
    //   //     isError: true,
    //   //     errorMessage: ``,
    //   //   },
    //   // });
    // }
  };

  handleCategoryChange = (label) => async (event) => {
    this.setState({ [label]: { value: event.target.value } });
    if (!!event.target.value) {
      let params = { plntype: REGULAR };
      params = {
        ...params,
        opt: "S",
        schemetype: event.target.value,
        fund: "189",
      };
      const types = [
        GET_SCHEME_LIST,
        GET_SCHEME_LIST_SUCCESS,
        GET_SCHEME_LIST_FAILED,
      ];
      const response = await this.props.getNewPurchaseFundList(params, types);

      if (response) {
        this.setState({
          [label]: { value: event.target.value },
          scheme: { value: "" },
          minCost: "",
        });
      }
    } else {
      this.setState({
        [label]: { value: event.target.value },
        scheme: { value: "" },
        minCost: "",
      });
    }
  };

  changeScheme = (value) => {
    const comboScheme =
      !!value &&
      !!value.value &&
      this.props.schemeList.find((ele) => ele.Scheme_Plan === value.value);
    this.setState({
      scheme: { value: value, isError: false, errorMessage: "" },
      minAmount: { value: "", isError: false, errorMessage: "" },
      minCost: !!comboScheme && !!comboScheme.MinAmt ? comboScheme.MinAmt : "",
      multiples:
        !!comboScheme && !!comboScheme.multiples ? comboScheme.multiples : "",
    });
    if (!!value) {
      this.validateBrokerCode();
    }
  };

  changeValue = (label) => (event) => {
    if (label === "minAmount" && event.target.value.length <= 10) {
      this.setState({
        [label]: { value: event.target.value },
      });
    } else if (label === "code") {  
      this.setState({ [label]: { value: event.target.value } });
    } else if (label === "mobile" ) {
      if (!/^[6-9]\d{9}$/.test(event.target.value) && (this.state.code.value === "+91")) {
        this.setState({
          [label]: {
            value: event.target.value,
            isError: true,
            errorMessage: "Enter a valid Mobile Number",
          },
        });
      } else {
        this.setState({ [label]: { value: event.target.value } });
      }
    } else if (
      (label === "subArnCode" || label === "subBrokerCode") &&
      event.target.value.length <= 20
    ) {
      this.setState({
        [label]: { value: event.target.value },
      });
      return;
    } else if (label === "invName") {
      if (/^[a-zA-Z ]*$/.test(event.target.value)) {
        this.setState({
          [label]: { value: event.target.value },
        });
      }
    } else if (
      label !== "mobile" &&
      label !== "invName" &&
      label !== "minAmount" &&
      label !== "subArnCode" &&
      label !== "subBrokerCode"
    ) {
      this.setState({
        [label]: { value: event.target.value },
      });
    }
  };

  changeEuin = (label) => (value) => {
    this.setState({
      [label]: { value },
    });
  };

  showError = (label) => (event) => {
    const {
      [label]: { value },
    } = this.state;
    if (label === "minAmount") {
      if (
        parseFloat(this.state.minCost) > parseFloat(this.state.minAmount.value)
      ) {
        this.setState({
          [label]: {
            value: "",
            isError: true,
            errorMessage: `The amount should be ₹ ${this.state.minCost} or more`,
          },
        });
      } else if (
        !!this.state.minAmount.value &&
        !!this.state.multiples &&
        parseFloat(this.state.minAmount.value) %
          parseFloat(this.state.multiples) !=
          0
      ) {
        this.setState({
          [label]: {
            value: "",
            isError: true,
            errorMessage: `The amount should be in the multiples of ${this.state.multiples}`,
          },
        });
      }
    } else if (label === "emailId") {
      this.setState({
        [label]: {
          value,
          isError:
            /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(
              this.state.emailId.value
            ) === false
              ? true
              : !value,
          errorMessage:
            /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(
              this.state.emailId.value
            ) === false
              ? `( *enter an vaild email address )`
              : "",
        },
      });
    } else if (label === "code") {
      if (!/^[+]\d{1,3}$/.test(event.target.value)) {
        this.setState({
          [label]: {
            value: "",
            isError: true,
            errorMessage: "Enter a valid Country Code",
          },
        });
      }
    } else if (label === "mobile" && (this.state.code.value === "+91")) {
      this.setState({
        [label]: {
          value,
          isError:
            /^(?:(?:\+|0{0,2})91(\s*[\-]\s*)?|[0]?)?[6-9]\d{9}$/.test(
              this.state.mobile.value
            ) === false
              ? true
              : !value,
          errorMessage:
            /^(?:(?:\+|0{0,2})91(\s*[\-]\s*)?|[0]?)?[6-9]\d{9}$/.test(
              this.state.mobile.value
            ) === false
              ? `(* Enter a valid Phone Number)`
              : !value,
        },
      });
    } else {
      this.setState({
        [label]: {
          value,
          isError: !value,
        },
      });
    }
  };

  submit = async () => {
    const { location } = this.props;
    const { state } = location;

    const {
      arnCode,
      combo,
      subArnCode,
      isCombo,
      radioValue,
      multiples,
      invName,
      euinNo,
      minCost,
      subBrokerCode,
      disbleEmail,
      disbleMobile,
      code,
      Family_Code_Email,
      Family_Code_Phone,
      ...others
    } = this.state;
    const arn = this.state.arnCode.value.split("-");
    if (!/^[+]\d{1,3}$/.test(code.value)) {
      this.setState({
        [code]: {
          value: "",
          isError: true,
          errorMessage: !code.value
            ? "Country Code is Mandatory"
            : "Enter a valid Country Code",
        },
      });
      return;
    }
    if (
      !/^[+]\d{1,3}/.test(this.state.code.value) &&
      (this.state.sipType.value === NEW || this.state.sipType.value === NEWP)
    ) {
      this.setState({
        code: {
          value: "",
          isError: true,
          errorMessage: !code.value
            ? "Country Code is Mandatory"
            : "Enter a valid Country Code",
        },
      });
      return;
    }
    if (radioValue.value === "no" && !euinNo.value) {
      this.setState({
        euinNo: {
          value: "",
          isError: true,
          errorMessage: "Euin is required to proceed",
        },
      });
    }

    if (this.state.invName.value === "") {
      this.setState({
        invName: {
          value: "",
          isError: true,
          errorMessage: "Investor Name is Mandatory*",
        },
      });
    }

    const keys = Object.keys(others);
    const findError = keys.every((key) => !!others[key].value);
    if (!findError) {
      keys.forEach((key) => {
        !others[key].value &&
          this.setState({
            [key]: {
              ...others[key],
              isError: true,
              errorMessage: `${
                key === "category"
                  ? "Please select a category to proceed"
                  : key === "scheme"
                  ? "Please select a scheme to proceed"
                  : key === "minAmount"
                  ? "Minimum Investment Amount is mandatory"
                  : key`${"is mandatory"} `
              } `,
            },
          });
      });
      const firstErroredKey = keys.find((key) => !others[key].value);
      switch (firstErroredKey) {
        case "emailId": {
          this.emailIdField.focus();
          break;
        }
        case "mobile": {
          this.mobileField.focus();
          break;
        }
        case "fund": {
          this.fundField.focus();
          break;
        }
        case "category": {
          this.categoryField.focus();
          break;
        }
        case "scheme": {
          this.schemeField.focus();
          break;
        }
        case "minAmount": {
          this.minAmountField.focus();
          break;
        }
        default:
          break;
      }
    } else if (invName.value === "") {
      this.setState({
        invName: {
          value: "",
          isError: true,
          errorMessage: "Investor Name is mandatory",
        },
      });
    } else if (radioValue.value === "no" && !euinNo.value) {
      this.setState({
        euinNo: {
          ...euinNo,
          isError: true,
          errorMessage: "EUIN No is mandatory",
        },
      });
      this.euinField.focus();
      return;
    } else if (minCost > others.minAmount.value) {
      this.setState({
        minAmount: {
          ...others["minAmount"],
          isError: true,
          errorMessage: `Minimum Amount should be ${minCost}`,
        },
      });
      this.minAmountField.focus();
      return;
    }
    // else if (others.minAmount.value > 1000000) {
    //   this.setState({
    //     minAmount: {
    //       ...others["minAmount"],
    //       isError: true,
    //       errorMessage: ` Amount should be less than or equal to 1,000,000`,
    //     },
    //   });
    //   this.minAmountField.focus();
    //   return;
    // }
    else if (
      /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(
        this.state.emailId.value
      ) === false
    ) {
      this.setState({
        emailId: {
          ...others["emailId"],
          isError: true,
          errorMessage: `Enter an vaild Email Id`,
        },
      });
      return;
    } else if (
      /^(?:(?:\+|0{0,2})91(\s*[\-]\s*)?|[0]?)?[6-9]\d{9}$/.test(
        this.state.mobile.value
      ) === false && this.state.code.value === "+91"
    ) {
      this.setState({
        mobile: {
          ...others["mobile"],
          isError: true,
          errorMessage: `Enter an vaild Phone Number`,
        },
      });
      return;
    } else if (arn[1] === this.state.subArnCode.value) {
      this.setState({
        subArnCode: {
          value: "",
          isError: true,
          errorMessage: `and ARN code should not match `,
        },
      });
    } else {
      const plan = this.state.scheme.value.value.split("~");

      const family_email_relationship = !!this.state.Family_Code_Email.value
        .value
        ? family_description_codes.find(
            (ele) =>
              ele.family_code === this.state.Family_Code_Email.value.value
          )
        : "";
      const family_mobile_relationship = !!this.state.Family_Code_Phone.value
        .value
        ? family_description_codes.find(
            (ele) =>
              ele.family_code === this.state.Family_Code_Phone.value.value
          )
        : "";

      const params = {
        InvestorName: this.state.invName.value,
        i_entby: this.props.userId,
        trtype: PURCHASE,
        Desci: "Yes~M~",
        SubbrokerArn: !!this.state.subArnCode.value
          ? `ARN-${subArnCode.value}`
          : "",
        ARNCode: this.state.arnCode.value,
        EuinCode:
          this.state.radioValue.value === "no"
            ? this.state.euinNo.value.value
            : "",
        i_Userid: this.props.userId,
        Mobile: this.state.mobile.value,
        PanNo: this.props.investorData.PAN || state.pan,
        Email: this.state.emailId.value,
        i_Acno: "0",
        Subbroker: this.state.subBrokerCode.value,
        i_Fund: "189",
        i_UntAmtValue: this.state.minAmount.value,
        EUINFlag: this.state.radioValue.value === "no" ? NO : YES,
        EuinValid: this.state.radioValue.value === "no" ? NO : YES,
        i_Scheme: plan[1],
        i_Plan: plan[2],
        i_Option: plan[3],
        i_oldihno: "0",
        i_InvDistFlag: "B",
        ModuleName: "Webile",
        customfund: "189",
        CountryCode: this.state.code.value,
        // comboswitch: !!this.state.isCombo ? "Y" : "N",
        fEmailFlag: this.state.Family_Code_Email.value.value,
        fMobileFlag: this.state.Family_Code_Phone.value.value,
      };
      const response = await this.props.submitPurchaseData(params);
      if (response) {
        const {
          DtData: [purchaseData],
        } = response;
        const confirmationParams = {
          Trtype: PURCHASE,
          fund: "189",
          customfund: "189",
          Refno: purchaseData.refno,
          ModuleName: "Webile",
        };

        const confirmationResponse = await this.props.showPurchaseConfirmation(
          confirmationParams
        );

        if (confirmationResponse) {
          this.props.saveTransactionDetails(this.state);
          this.props.history.push({
            pathname:
              NEW_TRANSACTION_URL +
              "/nfo-new-purchase/digital/transact/confirm",
            state: {
              title: "LUMPSUM SUMMARY",
              pan: !!state && !!state.pan ? state.pan : "",
              InvestorEmail: this.state.emailId.value,
              InvestorMobile: this.state.mobile.value,
              fEmailFlag: family_email_relationship,
              fMobileFlag: family_mobile_relationship,
              scheme: { Fund: this.state.fund.value.value },
              subArnCode: this.state.subArnCode.value,
              type: NEW_PURCHASE,
              arnCode: this.state.arnCode.value,
            },
          });
        }
      }
    }
  };

  // ComboChange = () => {
  //   this.setState({
  //     isCombo: !this.state.isCombo,
  //   });
  // };

  render() {
    const { schemeList, categoryList, euinList, investorData } = this.props;
    const filteredSchemeList = schemeList
      .map((item) => ({
        label: item.Scheme_Desc,
        value: item.Scheme_Plan,
      }))
      .filter((item) => {
        return item.value.split("~")[1] !== "EB";
      });
    const {
      emailId,
      mobile,
      arnCode,
      fund,
      invName,
      category,
      scheme,
      subArnCode,
      radioValue,
      euinNo,
      minAmount,
      subBrokerCode,

      Family_Code_Email,
      Family_Code_Phone,
    } = this.state;

    return (
      <React.Fragment>
        <div className="transaction-details">
          <div className="title">Lumpsum</div>
          {/* {!!state && !!state.pan && ( */}
          <div className="input-margin">
            <Input
              name="Investor Name"
              value={invName.value}
              // disabled={!!investorData && !!investorData.invname ? true : false}
              onChange={this.changeValue("invName")}
              onBlur={this.showError("invName")}
              errorMessage={invName.errorMessage}
              isShowError={invName.isError}
              inputref={(ele) => (this.invNameField = ele)}
            />
          </div>

          <div className="input-margin">
            <div className="input-name input-integrated-label">
              Email Family Description
            </div>
            <IntegrationReactSelect
              suggestions={family_description_codes.map((item) => ({
                label: item.family_description,
                value: item.family_code,
              }))}
              value={Family_Code_Email.value}
              placeholder="Select Family Description"
              handleChange={this.FamilyDescriptionEmail}
            />
          </div>
          {/* )} */}
          <div className="input-margin">
            <Input
              name="Email ID"
              value={emailId.value}
              disabled={!!this.state.disbleEmail}
              bordercolor="#a6a6a6"
              onChange={this.changeValue("emailId")}
              onBlur={this.showError("emailId")}
              isShowError={emailId.isError}
              inputref={(ele) => (this.emailIdField = ele)}
              errorMessage={this.state.emailId.errorMessage}
            />
          </div>
          <div className="input-margin">
            <div className="input-name input-integrated-label">
              Mobile Family Description
            </div>
            <IntegrationReactSelect
              suggestions={family_description_codes.map((item) => ({
                label: item.family_description,
                value: item.family_code,
              }))}
              value={Family_Code_Phone.value}
              placeholder="Select Phone Description"
              handleChange={this.FamilyDescriptionPhone}
            />
          </div>
          <div className="input-margin">
          <CustomizedSelect
              name="Country code"
              borderColor="#a6a6a6"
              handleChange={this.changeValue("code")}
              onBlur={this.showError("code")}
              value={this.state.code.value}
              placeholder="country code"
              // disabled={!fund.value}
              // inputRef={(ele) => (this.categoryField = ele)}
              isError={this.state.code.isError}
              errorMessage={this.state.code.errorMessage}
            >
              {countrycodeOptions.map((item, index) => (
                <MenuItem value={item.label} key={index}>
                  {item.label}
                </MenuItem>
              ))}
            </CustomizedSelect>
            </div>
          <div className="input-margin">
            <Input
              name="Phone No"
              // disabled={!!this.state.disbleMobile}
              type={mobile.value ? "text" : "number"}
              bordercolor="#a6a6a6"
              onKeyDown={(evt) =>
                (evt.key === "e" || evt.key === "." || evt.key === "-") &&
                evt.preventDefault()
              }
              value={mobile.value}
              onChange={this.changeValue("mobile")}
              onBlur={this.showError("mobile")}
              isShowError={mobile.isError}
              errorMessage={mobile.errorMessage}
              inputref={(ele) => (this.mobileField = ele)}
            />
          </div>

          <div className="input-margin">
            <CustomizedSelect
              name="Category"
              borderColor="#a6a6a6"
              handleChange={this.handleCategoryChange("category")}
              value={category.value}
              placeholder="Select Category"
              disabled={!fund.value}
              inputRef={(ele) => (this.categoryField = ele)}
              isError={category.isError}
              errorMessage={category.errorMessage}
            >
              {categoryList.map((item, index) => (
                <MenuItem value={item.fm_subcategory} key={index}>
                  {item.fm_subcategory}
                </MenuItem>
              ))}
            </CustomizedSelect>
          </div>

          <div className="input-margin">
            <div className="input-name input-integrated-label">Scheme</div>
            <IntegrationReactSelect
              suggestions={filteredSchemeList}
              value={scheme.value}
              placeholder="Select Scheme"
              handleChange={this.changeScheme}
              disabled={!category.value}
              inputRef={(ele) => (this.schemeField = ele)}
              isError={scheme.isError}
              errorMessage={scheme.errorMessage}
            />
          </div>

          <div className="input-margin">
            <Input
              name={`Minimum Investment Amount ${
                !!this.state.minCost
                  ? `(Minimum amount : ${this.state.minCost} ₹)`
                  : ""
              }`}
              bordercolor="#a6a6a6"
              onKeyDown={(evt) =>
                (evt.key === "e" || evt.key === "." || evt.key === "-") &&
                evt.preventDefault()
              }
              placeholder="Amount"
              step="1"
              type="number"
              value={minAmount.value}
              onChange={this.changeValue("minAmount")}
              onBlur={this.showError("minAmount")}
              errorMessage={minAmount.errorMessage}
              isShowError={minAmount.isError}
              inputref={(ele) => (this.minAmountField = ele)}
            />
          </div>

          <div className="input-margin">
            <Input
              name="ARN Code"
              bordercolor="#a6a6a6"
              value={arnCode.value.split("-")[1]}
              disabled={true}
            />
          </div>

          <div className="input-margin">
            <Input
              name="Sub ARN Code"
              onKeyDown={(evt) =>
                (evt.key === "e" || evt.key === "." || evt.key === "-") &&
                evt.preventDefault()
              }
              bordercolor="#a6a6a6"
              type="number"
              value={subArnCode.value}
              isShowError={subArnCode.isError}
              errorMessage={subArnCode.errorMessage}
              onBlur={this.validateBrokerCode}
              onChange={this.changeValue("subArnCode")}
              inputref={(ele) => (this.subArnField = ele)}
            />
          </div>

          <div className="input-margin">
            <Input
              name="Sub Broker Code"
              onKeyDown={(evt) =>
                (evt.key === "e" || evt.key === "." || evt.key === "-") &&
                evt.preventDefault()
              }
              bordercolor="#a6a6a6"
              value={subBrokerCode.value}
              onChange={this.changeValue("subBrokerCode")}
              inputref={(ele) => (this.subBrokerField = ele)}
            />
          </div>
          <div className="input-field-container">
            <div className="input-name">EUIN No</div>

            <FormControl component="fieldset">
              <RadioGroup
                aria-label="Search"
                name="search"
                value={radioValue.value}
                style={{ flexDirection: "row" }}
                onChange={this.changeValue("radioValue")}
              >
                <div className="investor-radio-button">
                  <FormControlLabel
                    value="yes"
                    control={
                      <Radio
                        className="investor-search-radio"
                        style={{ color: "#005DAC" }}
                      />
                    }
                    className="investor-formcontrol-label"
                    style={{ margin: 0 }}
                  />
                  <div className="investor-form-label">YES</div>
                </div>
                <div className="investor-radio-button">
                  <FormControlLabel
                    value="no"
                    control={
                      <Radio
                        className="investor-search-radio"
                        style={{ color: "#005DAC" }}
                      />
                    }
                    className="investor-formcontrol-label"
                    style={{ margin: 0 }}
                  />
                  <div className="investor-form-label">NO</div>
                </div>
              </RadioGroup>
            </FormControl>
          </div>
          {radioValue.value === "no" ? (
            <div className="input-margin">
              <IntegrationReactSelect
                suggestions={euinList.map((item) => ({
                  label: item.abm_agent,
                  value: item.abm_agent,
                }))}
                value={euinNo.value}
                placeholder="Select EUIN"
                handleChange={this.changeEuin("euinNo")}
                errorMessage={euinNo.errorMessage}
                disabled={!euinList.length}
                inputRef={(ele) => (this.euinField = ele)}
                isError={euinNo.isError}
              />
            </div>
          ) : (
            <div className="euin-text">
              I/We hereby confirm that the EUIN box has been intentionally left
              the blank by me/us as this is an 'execution-only' transaction
              without any interaction or advice by any personnel of the above
              distributor or notwithstanding the advice of in-appropriateness,if
              any provided by any personnel of the distributor and the
              distributor has not charged any advisory fees on this transaction
            </div>
          )}

          {/* <TextLink /> */}
          <div className="digital-form-button-next-div">
            <Signbutton buttontitle="Submit" onClick={this.submit} />
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default connect(
  ({ authReducer, transactions }) => {
    const { investorData, communicationDetails, token, userId } = authReducer;
    const {
      fundsList,
      schemeList,
      categoryList,
      euinList,
      transactionDetails,
    } = transactions;
    return {
      investorData,
      communicationDetails,
      token,
      fundsList,
      schemeList,
      categoryList,
      euinList,
      userId,
      transactionDetails,
    };
  },
  {
    getNewPurchaseFundList,
    getInvestorDetails,
    validateSubBroker,
    submitPurchaseData,
    showPurchaseConfirmation,
    saveTransactionDetails,
  }
)(NewPurchase);

export class TextLink extends Component {
  render() {
    return (
      <div style={{ margin: "0px 15px" }}>
        <div
          style={{
            fontSize: 14,
            color: "#003a74",
          }}
        >
          <span
            style={{
              fontFamily: "Rubik-Bold",
              fontSize: 16,
              color: "black",
            }}
          >
            *Note :
          </span>{" "}
          Pursuant to notice cum addendum dated March 27, 2021 the nomenclature
          of dividend option has been changed w.e.f. April 01, 2021.
        </div>

        <div
          style={{
            fontSize: 14,
            color: "#003a74",
            marginTop: 10,
          }}
        >
          IDCW - Income Distribution cum Capital Withdrawal option.{" "}
          <a
            style={{ textDecoration: "underline", color: "#005DAC" }}
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.miraeassetmf.co.in/docs/default-source/addendum-2019/notice---change-in-name-of-dividend-option(s)-discontinuation-of-email-address-as-opa-for-transaction-processing-and-designating-mr-siddharth-srivastava-ms-smita-vermani-as-key-personnel.pdf?sfvrsn=16bfd3a_2"
          >
            Click here
          </a>{" "}
          to view the notice
        </div>
      </div>
    );
  }
}

export const family_description_codes = [
  {
    family_description: "Self",
    family_code: "SE",
  },
  {
    family_description: "Spouse",
    family_code: "SP",
  },
  {
    family_description: "Dependent Children",
    family_code: "DC",
  },
  {
    family_description: "Dependent Siblings",
    family_code: "DS",
  },
  {
    family_description: "Dependent Parents",
    family_code: "DP",
  },
  {
    family_description: "Guardian",
    family_code: "GD",
  },
];
